import { learningPathwayURL } from "@app/constants/ApiEndPoints";
import axios from "axios";

export const getLearningPathwaysWithPagination = async (search) => {
	try {
		const response = await axios.get(learningPathwayURL + `?${search.toString()}`);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getLearningPathwayById = async (id: number) => {
	try {
		const response = await axios.get(learningPathwayURL + 'read/' + id );
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getAllActiveLearningPathways = async () => {
	try {
		const response = await axios.get(learningPathwayURL + "all");
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getStudSubjectLearningPathways = async (payload) => {
	try {
		const response = await axios.post(learningPathwayURL + "student/subjects", payload);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getLinkedStudSubjectLearningPathways = async (payload) => {
	try {
		const response = await axios.post(learningPathwayURL + "linked/student/subjects", payload);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getWorksheetsPDFByModuleId = async (moduleId) => {
	try {
		const response = await axios.get(learningPathwayURL + 'module/preview/' + moduleId, { responseType: 'blob' });
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const createLearningPathway = async (payload) => {
	try {
		const response = await axios.post(learningPathwayURL + "create", payload);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getPathwayConfigurationById = async (id: number) => {
	try {
		const response = await axios.get(learningPathwayURL + 'configuration/' + id );
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const updatePathwayNameAndStatus = async (id, payload) => {
	try {
		const response = await axios.put(learningPathwayURL + "update/" + id, payload);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const updatePathwayConfiguration = async (payload) => {
	try {
		const response = await axios.put(learningPathwayURL + "update-configuration", payload);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getLinkedSettingPatternsByStudent = async (payload: { student_id: number }) => {
	try {
		const response = await axios.post(learningPathwayURL + "linked/setting-pattern/by-student", payload);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};
